// import {SmetioSmartbox} from 
//     "./../../../classes/smetioSmartbox2/SmetioSmartbox.js";

// import {IconLeftTextRight} from 
//     "./../../../classes/iconAndTextCombinations/iconLeftTextRight/IconLeftTextRight.js";

// import {globalVar} from 
//     "./../../../variables/global_variables.js";   

// import {checkIfItIsEmpty} from 
//     "./../../checks/checkIfItIsEmpty.js";

export function getSmetioWikiSmartBox(content){

	// if( checkIfItIsEmpty(globalVar["smetioWikiSmartBox"]) ){

	// 	globalVar["smetioWikiSmartBox"] = new SmetioSmartbox();

	// };
    
    // globalVar["smetioWikiSmartBox"].title = "Smetio Wiki";
    
    // globalVar["smetioWikiSmartBox"].contentType = "wikiPage";
    // globalVar["smetioWikiSmartBox"].contentUniqueIdentifier = "hjdj";
	// const smartBoxContainer = globalVar["smetioWikiSmartBox"].getContentHolder(); 
	// const smartBoxId = globalVar["smetioWikiSmartBox"].getId();
	// const smartBoxCurrentState = $("#"+smartBoxId).attr("data-smetio-open-state");

	// /**** CHECK IF THE SMARTBOX IS ALREADY VISIBLE IF NOT THEN RENDER IT****/
	// if( checkIfItIsEmpty(smartBoxCurrentState) ){

	// 	const smartBox = globalVar["smetioWikiSmartBox"].render();

	// };

    // /**** 
    //  * 
    //  * CREATE A FUNCTION THAT WILL BE CALLED TO CLEAR THE MEMORY WHERE THE FORM OBJECT IS STORED 
    //  * THIS FUNCTION WILL BE CALLED ONCE THE SMARTBOX CLOSE BUTTON IS CLICKED
    //  * 
    //  * ****/

    // globalVar["smartBoxes"][smartBoxId]["closeFunction"] = function(){

    // 	/**** REMOVE THE globalVar["smetioWikiSmartBox"] FROM MEMORY WHEN THE SMARTBOX IS CLOSED ****/

    //     globalVar["smetioWikiSmartBox"] = null;

    // };

   
    // $("#"+smartBoxContainer).html(content);

	// /**** CHECK IF THE SMARTBOX IS MINIMIZED IF YES THEN PUT IT IN THE NORMALIZED STATE ****/

	// if( smartBoxCurrentState === "minimize" ){

	// 	globalVar["smetioWikiSmartBox"].normalize();

	// };


};